/*
 * @Author: zhouwei
 * @Date: 2019-10-18 13:58:32
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-07 17:20:48
 * @Desc: 统计数据/覆盖线索
*/
<template>
  <div class="clue">
    <channel
      :wx-data-pv1="wxDataPv1"
      :wx-data-pv2="wxDataPv2"
      :wx-data-uv1="wxDataUv1"
      :wx-data-uv2="wxDataUv2"
      :pv-options1="pvOptions1"
      :pv-options2="pvOptions2"
      :uv-options1="uvOptions1"
      :uv-options2="uvOptions2"
    ></channel>
    <div class="new-wx-clue">
      <div class="myCensusData-item-title">
        <i></i>
        <span>新增线索</span>
        <!-- <span class="no-use-line"></span> -->
      </div>
      <div v-if="addWxClue.length > 0">
        <mk-stacked
          :data="addWxClue"
          :options="wxClueOptions"
        ></mk-stacked>
      </div>
      <div
        v-else
        class="no-data"
      >
        <div class="no-data-img">
          <img
            src="@/assets/images/no-data.png"
            class="img"
          >
        </div>
        <div class="no-data-txt">
          暂无数据
        </div>
      </div>
    </div>
    <div class="wx-clue-uv">
      <div class="myCensusData-item-title">
        <i></i>
        <span>累计浏览人数（UV）</span>
      </div>
      <div v-if="wxClueUv.length > 0">
        <mk-stacked
          :data="wxClueUv"
          :options="wxClueOptions"
        ></mk-stacked>
      </div>
      <div
        v-else
        class="no-data"
      >
        <div class="no-data-img">
          <img
            src="@/assets/images/no-data.png"
            class="img"
          >
        </div>
        <div class="no-data-txt">
          暂无数据
        </div>
      </div>
    </div>
    <div class="wx-clue-pv">
      <div class="myCensusData-item-title">
        <i></i>
        <span>累计浏览量（PV）</span>
      </div>
      <div v-if="wxCluePv.length > 0">
        <mk-stacked
          :data="wxCluePv"
          :options="wxClueOptions"
        ></mk-stacked>
      </div>
      <div
        v-else
        class="no-data"
      >
        <div class="no-data-img">
          <img
            src="@/assets/images/no-data.png"
            class="img"
          >
        </div>
        <div class="no-data-txt">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import channel from '../../../../statistical-data/source-data/channel.vue'
import { BIZAPIS } from '@api'
export default {
  components: {
    channel
  },
  data () {
    return {
      wxDataPv1: [], // 来源渠道1
      pvOptions1: {}, // 来源渠道1配置
      wxDataPv2: [], // 来源渠道2
      pvOptions2: {}, // 来源渠道2配置
      wxDataUv1: [], // 来源构成1
      uvOptions1: {}, // 来源构成1配置
      wxDataUv2: [], // 来源构成2
      uvOptions2: {}, // 来源构成2配置
      addWxClue: [],
      wxClueUv: [],
      wxCluePv: [],
      wxClueOptions: {
        chart: {
          height: 400,
          width: 600,
          scale: {
            year: {
              type: 'time',
              mask: 'YYYY-MM-DD',
              tickInterval: 24 * 3600 * 1000 * 1
            }
          },
          padding: [60, 60, 60, 60]
        },
        axis: [
          {
            dataTime: 'year'
          },
          {
            name: 'value'
          }
        ],
        geom: [
          {
            type: 'areaStack',
            position: 'year*value',
            color: 'country'
          },
          {
            type: 'lineStack',
            position: 'year*value',
            color: 'country',
            size: 2
          }
        ]
      }
    }
  },
  created () {
    this.getPvData()
    this.getUvData()
    this.scensusNewClue()
    this.scensusPvClue()
    this.scensusUvClue()
  },
  methods: {
    handleMerge (arr) {
      // 合并下列数据,后台存在返回两条一摸一样的数据
      // let data = [
      //   {
      //     attachCount: 1,
      //     day: '2019-10-31',
      //     materialId: 'b4133868-e1d2-46a2-82ad-6361010e633e',
      //     materialType: 'article',
      //     title: '高级脸VS塑胶感 同是美人差别在哪？'
      //   },
      //   {
      //     attachCount: 1,
      //     day: '2019-10-31',
      //     materialId: 'b4133868-e1d2-46a2-82ad-6361010e633e',
      //     materialType: 'article',
      //     title: '高级脸VS塑胶感 同是美人差别在哪？'
      //   }
      // ]
      if (arr instanceof Array) {
        for (let i = 0; i < arr.length; i++) {
          for (let j = i + 1; j < arr.length; j++) {
            if (
              arr[i].day === arr[j].day &&
              arr[i].materialId === arr[j].materialId &&
              arr[i].materialType === arr[j].materialType &&
              arr[i].title === arr[j].title
            ) {
              arr[i].attachCount += arr[j].attachCount
              arr.splice(j, 1)
              j--
            }
          }
        }
      }
    },
    async scensusNewClue (taskID, title, type) {
      // 新增微信线索
      const res = await BIZAPIS.StatisticsApi.timingPlanNewClueStatisticsGet({
        planID: this.$route.query.id
      })
      if (res.success) {
        let data = res.data.data
        this.handleMerge(data)
        let arr = []
        if (data instanceof Array) {
          data.forEach((item, index) => {
            let str = ''
            if (item.materialType === 'article') {
              str = '文章'
            } else if (item.materialType === 'form') {
              str = '表单'
            } else if (item.materialType === 'friend') {
              str = '朋友圈'
            }
            arr[index] = {
              country: '分享' + str + item.title,
              year: new Date(item.day),
              value: item.attachCount
            }
          })
          this.addWxClue = arr
        }
      }
    },
    async scensusPvClue (taskId, title, type) {
      // 微信线索访问量(Pv)
      const res = await BIZAPIS.StatisticsApi.timingPlanNewCluePvGet({
        planID: this.$route.query.id
      })
      if (res.success) {
        if (res.data.data && res.data.data.length > 0) {
          let data = res.data.data
          this.handleMerge(data)
          let arr = []
          if (data instanceof Array) {
            data.forEach((item, index) => {
              let str = ''
              if (item.materialType === 'article') {
                str = '文章'
              } else if (item.materialType === 'form') {
                str = '表单'
              } else if (item.materialType === 'friend') {
                str = '朋友圈'
              }

              arr[index] = {
                country: '分享' + str + item.title,
                year: new Date(item.day).getTime(),
                value: item.attachCount
              }
            })
            this.wxCluePv = arr
          }
        }
      }
    },
    async scensusUvClue (taskId, title, type) {
      // 微信线索访问人数(Uv)
      const res = await BIZAPIS.StatisticsApi.timingPlanNewClueUvGet({
        planID: this.$route.query.id
      })
      if (res.success) {
        if (res.data.data && res.data.data.length > 0) {
          let data = res.data.data
          this.handleMerge(data)
          let arr = []
          if (data instanceof Array) {
            data.forEach((item, index) => {
              let str = ''
              if (item.materialType === 'article') {
                str = '文章'
              } else if (item.materialType === 'form') {
                str = '表单'
              } else if (item.materialType === 'friend') {
                str = '朋友圈'
              }
              arr[index] = {
                country: '分享' + str + item.title,
                year: new Date(item.day).getTime(),
                value: item.attachCount
              }
            })
            this.wxClueUv = arr
          }
        }
      }
    },
    async getPvData () {
      // 获取来源渠道PV
      const res = await BIZAPIS.StatisticsApi.timingPlanSourcePvGet({
        planId: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        if (data.circle === 0 && data.contact === 0) {
          this.wxDataPv1 = []
        } else {
          this.wxDataPv1 = [
            { item: '朋友圈', count: data.circle },
            { item: '分享微信好友', count: data.contact }
          ]
          this.pvOptions1 = {
            chart: {
              width: 400,
              height: 400,
              padding: ['20%', '32%']
            },
            coord: {
              innerRadius: 0.8
            },
            html: {
              text: '累计浏览量<br/>（PV）',
              subtext: data.circle + data.contact,
              unit: ''
            }
          }
        }
        if (data.forward === 0 && data.share === 0) {
          this.wxDataPv2 = []
        } else {
          this.wxDataPv2 = [
            { item: '转发', count: data.forward },
            { item: '销售直接分享', count: data.share }
          ]
          this.pvOptions2 = {
            chart: {
              width: 400,
              height: 400,
              padding: ['20%', '32%']
            },
            coord: {
              innerRadius: 0.8
            },
            html: {
              text: '累计浏览量<br/>（PV）',
              subtext: data.forward + data.share,
              unit: ''
            }
          }
        }
      }
    },
    async getUvData () {
      // 获取来源构成UV
      const res = await BIZAPIS.StatisticsApi.timingPlanSourceUvGet({
        planId: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        if (data.oldClue === 0 && data.newClue === 0) {
          this.wxDataUv1 = []
        } else {
          this.wxDataUv1 = [
            { item: '新线索', count: data.newClue },
            { item: '老线索', count: data.oldClue }
          ]
          this.uvOptions1 = {
            chart: {
              width: 400,
              height: 400,
              padding: ['20%', '34%']
            },
            coord: {
              innerRadius: 0.8
            },
            html: {
              text: '累计浏览人数<br/>（ UV）',
              subtext: data.newClue + data.oldClue,
              unit: ''
            },
            color: ['item', ['#4ECB73', '#FBD437']]
          }
        }
        if (data.contact === 0 && data.noContact === 0) {
          this.wxDataUv2 = []
        } else {
          this.wxDataUv2 = [
            { item: '微信好友', count: data.contact },
            { item: '非好友', count: data.noContact }
          ]
          this.uvOptions2 = {
            chart: {
              width: 400,
              height: 400,
              padding: ['20%', '34%']
            },
            coord: {
              innerRadius: 0.8
            },
            html: {
              text: '累计浏览人数<br/>（ UV）',
              subtext: data.contact + data.noContact,
              unit: ''
            },
            color: ['item', ['#4ECB73', '#FBD437']]
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.clue {
  margin-top: 32px;
  margin-bottom: 100px;

  .wx-clue-uv,
  .wx-clue-pv {
    margin-top: 100px;
  }

  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding-bottom: 100px;
    padding: 50px 0;

    .no-data-img {
      width: 80px;
      height: 59px;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .no-data-txt {
      font-size: 14px;
      margin-top: 12px;
      color: #bfbfbf;
    }
  }

  .myCensusData-item {
    .txt {
      margin-left: 64px;
      margin-bottom: 8px;
    }
  }

  .myCensusData-item-title {
    display: flex;
    align-items: center;

    i {
      display: block;
      width: 4px;
      height: 16px;
      background-color: #009cff;
      border-radius: 1px;
      margin-right: 8px;
    }

    span {
      font-size: 13px;
      line-height: 13px;
      color: #262626;
      font-weight: 500;
    }
  }
}
</style>
